export const STATUS_AKTIF = 11
export const STATUS_NONAKTIF = 12
export const STATUS_PENDING = 13
export const STATUS_REJECT = 14
export const STATUS_BLOKIR = 15
export const M_JENIS_SIM = {
  1: 'SIM Tenant',
  2: 'SIM Organisasi',
}
export const M_PERAN_AKSES = {
  2: 'Admin',
  3: 'Operator',
  4: 'User',
}

export default {
    STATUS_AKTIF,
    STATUS_NONAKTIF,
    STATUS_PENDING,
    STATUS_REJECT,
    STATUS_BLOKIR,
    M_JENIS_SIM,
    M_PERAN_AKSES,
}
